<script setup lang="ts">
import { ref, computed } from "vue";

import type { AvatarItem } from "../api/models";

const props = defineProps<{ items: Array<AvatarItem>; ids: Array<string> }>();
const emit = defineEmits<{ (e: "update:ids", value: Array<string>): void }>();

const items = computed<Array<AvatarItem>>({
  get() {
    return props.items;
  },
  set() {}
});

const ids = computed<Array<string>>({
  get() {
    return props.ids;
  },
  set(value) {
    emit('update:ids', value);
  }
});
</script>

<template>
  <el-select v-model="ids" class="m-2" placeholder="选择微信账号" size="large" :clearable="true" multiple>
    <el-option v-for="item in items" :key="item.id" :label="item.name" :value="item.id"
      style="line-height: 30px;">
      <el-image style="width: 26px; height: 26px; vertical-align: middle;" :src="item.imageUrl" fit="fill" />
      <span style="padding-left: 10px;">{{ item.name }}</span>
    </el-option>
  </el-select>
</template>

<style scoped>
.image-slot .el-icon {
  font-size: 26px;
}
</style>
